var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupe297(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{fill:#8c8e8e;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-285 -525)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(285 525)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 15,
    cy: 15,
    r: 14.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4.883,9.063a2.965,2.965,0,0,0-2.847,2.118.447.447,0,0,1-.427.292c-.325,0-1.332-.811-1.619-1.006C-.01,12.879,1.1,15,3.74,15c2.222,0,3.75-1.282,3.75-3.521a2.538,2.538,0,0,0-.028-.267L4.883,9.063ZM13.405,0a1.789,1.789,0,0,0-1.178.482c-5.989,5.35-6.612,5.475-6.612,7.05a2.712,2.712,0,0,0,.256,1.134l1.87,1.558a2.7,2.7,0,0,0,.656.089c1.82,0,2.874-1.332,6.186-7.513a3.014,3.014,0,0,0,.407-1.347A1.526,1.526,0,0,0,13.405,0Z",
    transform: "translate(293.01 533)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupe297);
export default __webpack_public_path__ + "static/media/Groupe_297.1ed86869916d0953636543d368ea3a3a.svg";
export { ForwardRef as ReactComponent };